import { loadPinmap } from './abTest'
import companyApiInstance from './companyApiInstance'
import {
  iframeLoadedShopify,
  iframeLoadedWoocommerceVtex
} from './iframeLoadedCmsHelper'
import {
  companyInfoAvailable,
  getUserInfoLocalStorage,
  isLocalStorageAvailable,
  setCompanyLocalStorage
} from './localStorage'
import { decryptToken, getPinflagApiKey } from './utils'

const REQUEST_TIMEOUT = 2000

const processCompanyData = (data, pinflagApiKey) => {
  let labelPricePickup = data.storePickupPriceLabel
  if (!isNaN(parseInt(data.storePickupPriceLabel))) {
    labelPricePickup = '$' + data.storePickupPriceLabel
  }

  return {
    logoUrl: data.logoUrl,
    primaryColor: data.primaryColor || '#394860',
    secondaryColor: data.secondaryColor || '#00B7F9',
    companyName: data.company?.nombreempresa || data.companyName,
    userId: data.company?.userId || data.userId,
    pinflagApiKey,
    ccDiscountPercentageLabel: data.ccDiscountPercentageLabel,
    storePickupPriceLabel: labelPricePickup,
    storePickupTypeLabel: data.storePickupTypeLabel,
    checkout: data.checkout,
    useBillingData: data.useBillingData,
    useSsn: data.useSsn,
    useDiscountCode: data.useDiscountCode,
    useGiftCard: data.useGiftCard,
    mapboxToken: data.mapboxToken
      ? decryptToken(
        data.mapboxToken,
        process.env.REACT_APP_TOKEN_ENCRYPTATION_KEY
      ) || process.env.REACT_APP_MAPBOX_TOKEN
      : process.env.REACT_APP_MAPBOX_TOKEN,
    usePixelEvents: data.usePixelEvents,
    selectedCheckout: data.selectedCheckout
  }
}

const setCompanyInfoData = (
  companyObject,
  setCompanyInfo,
  pinflagApiKey,
  shouldSaveToLocalStorage = true
) => {
  iframeLoadedShopify(loadPinmap(companyObject.checkout), {
    companyName: companyObject.companyName,
    cms: 'shopify',
    pinflagApiKey
  })
  iframeLoadedWoocommerceVtex(loadPinmap(companyObject.checkout))

  if (shouldSaveToLocalStorage && isLocalStorageAvailable()) {
    setCompanyLocalStorage(companyObject)
  }

  setCompanyInfo((prevState) => ({
    ...prevState,
    ...companyObject,
    mapboxToken:
      companyObject.mapboxToken &&
      !['null', 'undefined'].includes(companyObject.mapboxToken)
        ? companyObject.mapboxToken
        : process.env.REACT_APP_MAPBOX_TOKEN
  }))
}

const requestCompanyInfoFromParent = (pinflagApiKey, onResponse) => {
  if (window.self === window.top) {
    onResponse(null)
    return
  }

  let resolved = false
  const timeoutId = setTimeout(() => {
    if (!resolved) {
      resolved = true
      window.removeEventListener('message', messageHandler)
      onResponse(null)
    }
  }, REQUEST_TIMEOUT)

  const messageHandler = (event) => {
    if (
      event.data?.type === 'response-company-info' &&
      event.data?.pinflagApiKey === pinflagApiKey &&
      !resolved
    ) {
      resolved = true
      clearTimeout(timeoutId)
      window.removeEventListener('message', messageHandler)
      onResponse(event.data.message)
    }
  }

  window.addEventListener('message', messageHandler)

  window.parent.postMessage(
    {
      type: 'request-company-info',
      origin: 'pinflag-shopify-pinmap-pro',
      pinflagApiKey,
      message: true
    },
    '*'
  )
}

const fetchCompanyInfoFromAPI = (pinflagApiKey) => {
  return companyApiInstance(pinflagApiKey)
    .get('/company/personalization', {
      cache: {
        maxAge: 5 * 60 * 1000,
        exclude: { query: false }
      }
    })
    .then((res) => res.data)
    .catch((err) => {
      console.error(err)
      throw err
    })
}

export const getCompanyInfoHelper = (setUserInfo, setCompanyInfo) => {
  const preloadUserInfo = () => {
    setUserInfo((prevState) => ({
      ...prevState,
      ...getUserInfoLocalStorage()
    }))
  }

  const pinflagApiKey = getPinflagApiKey()
  preloadUserInfo()
  if (isLocalStorageAvailable()) {
    const companyLocalStorage = companyInfoAvailable(pinflagApiKey)
    if (companyLocalStorage) {
      setCompanyInfoData(companyLocalStorage, setCompanyInfo, pinflagApiKey, false)
      return
    }
  }

  if (!pinflagApiKey) {
    return
  }

  requestCompanyInfoFromParent(pinflagApiKey, (parentCompanyInfo) => {
    if (parentCompanyInfo) {
      const companyObject = processCompanyData(
        parentCompanyInfo,
        pinflagApiKey
      )
      setCompanyInfoData(companyObject, setCompanyInfo, pinflagApiKey, true)
      return
    }

    fetchCompanyInfoFromAPI(pinflagApiKey)
      .then((apiData) => {
        const companyObject = processCompanyData(apiData, pinflagApiKey)
        setCompanyInfoData(companyObject, setCompanyInfo, pinflagApiKey, true)
      })
      .catch((err) => {
        iframeLoadedShopify(false, {
          companyName: 'Unknown',
          cms: 'shopify',
          pinflagApiKey
        })
        iframeLoadedWoocommerceVtex(false)
        setCompanyInfo((prevState) => ({
          ...prevState,
          pinflagApiKey
        }))
        console.error(err)
      })
  })
}
